export const SITE_NAME = "!tldr";

/** Where canonical urls point; the prerendered pages are the ones `www` serves. */
export const SITE_ORIGIN = "https://www.nottldr.com";

export const DEFAULT_TITLE = "Not Too Long, Did Read";

export const DEFAULT_DESCRIPTION =
  "!tldr (Not Too Long, Did Read) is a website that provides AI generated, concise articles to make complex topics easier to understand.";

export const FAVICON = "/static/logo/nottldr_logo_black.png";

/** The document title: `Page | !tldr`, and `Not Too Long, Did Read | !tldr` without a page. */
export const titleOf = (title?: string): string => `${title ?? DEFAULT_TITLE} | ${SITE_NAME}`;

export const absoluteUrl = (path: string): string => `${SITE_ORIGIN}${path}`;
